import { useState, useEffect } from 'react';
import { Order } from '../../types/order';
import {
  DateFilter,
  filterOrdersByDate,
  filterOrdersByStatus,
  filterOrdersBySearch,
} from '../../utils/orderUtils';

export const useUserOrdersFilters = (orders: Order[]) => {
  const [filteredOrders, setFilteredOrders] = useState<Order[]>(orders);
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilter, setDateFilter] = useState<DateFilter>('all');

  useEffect(() => {
    let filtered = orders;

    // Durum filtresi
    filtered = filterOrdersByStatus(filtered, statusFilter);

    // Tarih filtresi
    filtered = filterOrdersByDate(filtered, dateFilter);

    // Arama filtresi
    filtered = filterOrdersBySearch(filtered, searchTerm);

    setFilteredOrders(filtered);
  }, [orders, statusFilter, searchTerm, dateFilter]);

  const getStatusCount = (status: string) => {
    return orders.filter(order => order.status === status).length;
  };

  const resetFilters = () => {
    setStatusFilter('all');
    setSearchTerm('');
    setDateFilter('all');
  };

  return {
    filteredOrders,
    statusFilter,
    setStatusFilter,
    searchTerm,
    setSearchTerm,
    dateFilter,
    setDateFilter,
    getStatusCount,
    resetFilters,
  };
};
